import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

interface EmspBoChargingSessionListEnergyDeliveredCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['energyDelivered']
  > {}

export const EmspBoChargingSessionListEnergyDeliveredCell = ({
  getValue,
}: EmspBoChargingSessionListEnergyDeliveredCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  // TODO: `energy delivered` may be optionnal, but the interface does not
  // reflect it, we should check with the backend team if it can be optionnal or
  // not, and update the interface if needed

  if (!getValue()) {
    return <span>—</span>;
  }

  return <span>{getValue().toFixed(2)} kWh</span>;
};
